import React, { ReactNode } from 'react';
import { textTitle3 } from '../../styles/typography';
import { classNames } from '../../utils/style';
import { DefaultBsComponent, PayFitColor } from '../../types/module';
import { Image } from '../Image';
import { applyBgLightColor } from '../../utils/utils';
import { ImageProps } from '../Image/types';
export interface BlogBannerProps extends DefaultBsComponent {
  title: string;
  backgroundColor?: PayFitColor;
  image?: ImageProps;
  cta?: ReactNode;
}

export const BlogBanner = ({
  image,
  backgroundColor = 'blue',
  title,
  cta,
}: BlogBannerProps) => {
  return (
    <div
      className={classNames(
        'BlogBanner',
        applyBgLightColor(backgroundColor),
        'p-24 rounded-12 flex flex-col sm:flex-row banner',
      )}
    >
      {image && (
        <div className="mb-16 sm:mb-0  sm:mr-24 w-full sm:w-auto sm:max-w-1/2">
          <div
            className={
              'rounded-6 bg-blue-301 h-[162px] sm:w-[178px] sm:h-[128px] max-w-full overflow-hidden'
            }
          >
            <Image
              {...image}
              className="w-full h-full object-cover"
              sizes={['178px']}
            />
          </div>
        </div>
      )}
      <div
        className={classNames(
          'flex w-full',
          image
            ? 'flex-col items-center sm:items-start sm:justify-center text-center sm:text-left'
            : 'flex-col sm:flex-row items-center sm:w-auto',
        )}
      >
        <div
          className={classNames(
            textTitle3,
            !image && 'flex-1',
            'text-center sm:text-left',
          )}
        >
          {title}
        </div>
        {cta && cta}
      </div>
    </div>
  );
};
